module.exports = function (apiEndpoint) {
    $('.search-rendering__modaal-filters-link').modaal({
        custom_class: "search-rendering__modaal-filters",        
        after_close: function () {
            ICF.Modules.SearchRendering.InsertResults(apiEndpoint);
        }
    });
};